/* tslint:disable */
/* eslint-disable */
/**
 * bi-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserAggregate1 } from './UserAggregate1';
import {
    UserAggregate1FromJSON,
    UserAggregate1FromJSONTyped,
    UserAggregate1ToJSON,
    UserAggregate1ToJSONTyped,
} from './UserAggregate1';
import type { Token } from './Token';
import {
    TokenFromJSON,
    TokenFromJSONTyped,
    TokenToJSON,
    TokenToJSONTyped,
} from './Token';

/**
 * 
 * @export
 * @interface VerifyOTPChallengeResponse
 */
export interface VerifyOTPChallengeResponse {
    /**
     * 
     * @type {string}
     * @memberof VerifyOTPChallengeResponse
     */
    status: VerifyOTPChallengeResponseStatusEnum;
    /**
     * 
     * @type {Token}
     * @memberof VerifyOTPChallengeResponse
     */
    token?: Token;
    /**
     * 
     * @type {UserAggregate1}
     * @memberof VerifyOTPChallengeResponse
     */
    user?: UserAggregate1;
    /**
     * 
     * @type {Date}
     * @memberof VerifyOTPChallengeResponse
     */
    retry_at?: Date;
}


/**
 * @export
 */
export const VerifyOTPChallengeResponseStatusEnum = {
    logged_in: 'logged_in',
    access_changed: 'access_changed',
    code_already_used: 'code_already_used',
    rate_limited: 'rate_limited'
} as const;
export type VerifyOTPChallengeResponseStatusEnum = typeof VerifyOTPChallengeResponseStatusEnum[keyof typeof VerifyOTPChallengeResponseStatusEnum];


/**
 * Check if a given object implements the VerifyOTPChallengeResponse interface.
 */
export function instanceOfVerifyOTPChallengeResponse(value: object): value is VerifyOTPChallengeResponse {
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function VerifyOTPChallengeResponseFromJSON(json: any): VerifyOTPChallengeResponse {
    return VerifyOTPChallengeResponseFromJSONTyped(json, false);
}

export function VerifyOTPChallengeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): VerifyOTPChallengeResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'],
        'token': json['token'] == null ? undefined : TokenFromJSON(json['token']),
        'user': json['user'] == null ? undefined : UserAggregate1FromJSON(json['user']),
        'retry_at': json['retry_at'] == null ? undefined : (new Date(json['retry_at'])),
    };
}

export function VerifyOTPChallengeResponseToJSON(json: any): VerifyOTPChallengeResponse {
    return VerifyOTPChallengeResponseToJSONTyped(json, false);
}

export function VerifyOTPChallengeResponseToJSONTyped(value?: VerifyOTPChallengeResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': value['status'],
        'token': TokenToJSON(value['token']),
        'user': UserAggregate1ToJSON(value['user']),
        'retry_at': value['retry_at'] == null ? undefined : ((value['retry_at']).toISOString()),
    };
}

